import { render, staticRenderFns } from "./PixOrderCreated.vue?vue&type=template&id=6099be0a&"
import script from "./PixOrderCreated.vue?vue&type=script&lang=js&"
export * from "./PixOrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports